import { render } from "./FinancialDashboard.vue?vue&type=template&id=2c4ff9ea"
import script from "./FinancialDashboard.vue?vue&type=script&lang=js"
export * from "./FinancialDashboard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\agents\\Oreo\\_work\\93\\s\\NcasReporting\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__